// LinkedIn recommendations / client testimonials.
//
// HOW TO EDIT:
// 1. Open your LinkedIn profile → Recommendations → pick the ones you want to feature
// 2. For each recommendation, paste the EXACT text as a new object below:
//    { name, role, company, quote, linkedin }
// 3. Save this file, commit, git push — Cloudflare redeploys automatically.
//
// If the array is empty, the Testimonials section does NOT render on the site.
//
// Recommended: 3–6 recommendations. Keep each quote ≤ ~60 words for best visual rhythm.
//
// Example:
// {
//   name: "Jane Doe",
//   role: "Managing Director",
//   company: "Acme Renewables",
//   quote: "Himansshu brought clarity to a complex techno-commercial problem...",
//   linkedin: "https://www.linkedin.com/in/janedoe/",
// },

export const testimonials = [
  // paste your real recommendations here
];
